import React, { useState, useEffect, useRef } from 'react'
import { masterData } from '../api/master-data';
import Footer from './Layout/Footer';
import Header from './Layout/Header';
import Sidebar from './Layout/Sidebar';
import Swal from "sweetalert2";
import Pagination from './Layout/Pagination';
import { putAPI,postAPI, uploadImageAPI,get, deleteAPI } from '../services/ApiService';
import "react-datepicker/dist/react-datepicker.css";


function Redeem() {
    const [errors, setErrors] = useState({});//for error handling
    const [loadecheck, setLoadCheck] = useState(false);
    const [pageInfo, setPagination] = useState({});
    const dataFetchedRef = useRef(false);//used for preventing double loading logic
    const [searchKeyword, setSearchKeyword] = useState();
    const [lists, setLists] = useState();//list of redeems
    const [redeem, setRedeemDetail] = useState({});//detail of a redeem
    const [startDate, setStartDate] = useState(new Date());//datepicker start date
    const [endDate, setEndDate] = useState(new Date());//datepicker end date
    
    //Master Data holders
    const [countries, setCountries] = useState();
    const [countryId, setCountryId] = useState();    
    const [currencies, setCurrencies] = useState();
    const [currencyId, setCurrencyId] = useState();
    
     
    //end master data holders

    useEffect(() => {
        document.title = "Redeem - GoToSample"   
        //if(dataFetchedRef.current){ // to stop double loading of APIs, skips in first mount
            const getCountries = async() => {
                let res = await masterData({moduleName:'country'})
                if(res.status === 1){
                    setCountries(res.payload)
                }
            };
            getCountries();
            const getCurrencies = async() => {
                let res = await masterData({moduleName:'currency'})
                if(res.status === 1){
                    setCurrencies(res.payload)
                }
            } 
            getCurrencies();

            getList();
    // }
        //  dataFetchedRef.current = true;

    },[]);

    //UI/UX level and form control functions
    const setRedeemFields = (details)=>{
        //setVisibleredeemForm({visible:true,title:"Edit Redeem"});
        
        setRedeemDetail(details);          
    }

    

    
//end UI/UX level functions

//START API level/called functions, considering to move to another file
    const getList = async() =>{
        if(document.getElementById("dataMessage"))
        document.getElementById("dataMessage").innerHTML = "Loading . . .";
        let data = {page: pageInfo.current_page?pageInfo.current_page:0,recPerPage: 50, q: searchKeyword}
        let res = await get('/redeem/list', data);        
            if(res.status === 1){
                setLists(res.payload)
                setPagination(res.paginationInfo)
            }else{
            setLists([]);
            Swal.fire({
                text:res.message,
                timer: 2000,
            })
        if(document.getElementById("dataMessage"))
            document.getElementById("dataMessage").innerHTML = res.message;
            }
    }

    const changePage = (p) => {
        pageInfo.current_page = p;
        getList();
    }
    
    const submitRedeem = async (e) => {
        e.preventDefault();
        setErrors();

        const formData = new FormData(e.target);
        let formInput = {};
        for (const [key, value] of formData) {
            formInput[key] = value;
        }
        // const formErrors = validateFormData(formData)
        // if(Object.keys(formErrors).length > 0){
        //     //setErrors(formErrors)
        // }else{
        let res = {};
            if(!redeem || !redeem.ID)
            res = await postAPI('/redeem/save', formInput)
            else
            res = await putAPI('/redeem/update/'+redeem.ID, formInput)
            if(res.status === 1){
                setRedeemDetail({});
                getList();           
                Swal.fire({text:res.message
                ,timer:2500})      
             }
            else{
                setErrors({...errors,['saveRedeem']:res.message})
             }
        //}
    }

    const updateRedeemStatus = async (redeemId,status) => {
        // e.preventDefault();
        //setErrors();
        status = status==0?1:0;
        let formData = {
            ID:redeemId,
            status:status
        };
        // const formErrors = validateFormData(formData)
        // if(Object.keys(formErrors).length > 0){
        //     //setErrors(formErrors)
        // }else{
            let res = await putAPI('/redeem/update-status/'+redeemId+'/'+status, formData);
            if(res.status === 1){
                getList();
               
             }
            //else{
            //     //setErrors({...errors,['submit']:res.message})
            // }
        //}
    }
    
    const trashRedeem = async (redeemId) => {
        // e.preventDefault();
        setErrors();

        Swal.fire({
            title: 'Are you sure?',
            text: "You are deleting a redeem. You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then(async (result) => {
            if (result.isConfirmed) {
                let formData = {
                    ID:redeemId,
                };      
                let res = await deleteAPI('/redeem/delete/'+redeemId+'/', formData)
                if(res.status === 1){
                    Swal.fire(
                        'Deleted!',
                        'Redeem has been deleted.',
                        'success'
                      )
                    getList();
                }else{
                    Swal.fire(
                        'Not Deleted!',
                        'Redeem could be deleted.',
                        'failure'
                      )
                }              
            }
          })        
    }  
    
    function decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

// END API called functions

    return (
        <div>
            <Header />
            <Sidebar />
            <div id="layout-wrapper">
                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">

                            {/* <!-- start page title --> */}
                            <div className="row">
                                <div className="col-12 col-lg-12 col-xl-12 col-md-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0">Manage Redeem</h4>

                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                {/* <li className="breadcrumb-item"><a >Dashboards</a></li> */}
                                                <li className="breadcrumb-item active">Manage Redeem</li>
                                            </ol>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}
                          
                           
                            <form  id="redeemForm" className='row' onSubmit={submitRedeem}>
                                <div id='point-message' style={{color:"red"}}>{errors?.saveRedeem}</div>
                                <div className="col-md-3">
                                    <div className="mb-3">
                                        <label className="form-label mb-0">Country</label>                                        
                                        <select id="countryId" name='countryId' className="form-select" data-choices data-choices-sorting="true"  >
                                            <option value={""}  selected>Select Country</option>                                              
                                            {countries?.map((row) => {
                                                return (<option value={row.id} selected={row.id == redeem?.countryId ? true : false} >{row.name}</option>)
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-3">
                                        <label className="form-label mb-0">Currency </label>
                                        <select id="currencyId" name='currencyId' className="form-select" data-choices data-choices-sorting="true"  onChange={(e)=> setCurrencyId(e.target.value)} >
                                            <option value={""}  selected>Select Currency</option>
                                                {currencies?.map((row) => {
                                                    return (<option value={row.id} selected={row.id == redeem?.currencyId ? true : false}  >{row.name}</option>)
                                                })}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-3">
                                        <label className="form-label mb-0">Currency HTML Code</label>
                                        <input type="text" className="form-control" placeholder="Enter HTML code ..."  name="currencySymbol" id="currencySymbol" defaultValue={redeem?.currencySymbol} />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="mb-3">
                                        <label className="form-label mb-0">Currency/Points</label>
                                        <input type="number" step="any" min={0} max={1000} className="form-control" placeholder="Enter points per currency ..."  name="currencyPoints" id="currencyPoints" defaultValue={redeem?.currencyPoints} />
                                    </div>
                                </div>
                                
                                                            
                                {/* <div className="col-md-3">
                                    <div className="mb-3">
                                        <label className="form-label mb-0">Start Date</label>
                                        <DatePicker className='form-control' selected={redeem?.startDateStd?redeem?.startDateStd:startDate} onChange={(date) => setStartDate(date)} name="startDate" id="startDate" dateFormat="d-MM-yyyy" defaultValue={redeem?.startDate} />
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="mb-3">
                                        <label className="form-label mb-0">End Date</label>
                                        <DatePicker className='form-control' selected={redeem?.endDateStd?redeem?.endDateStd:endDate} onChange={(date) => setEndDate(date)} name="endDate" id="endDate" dateFormat="d-MM-yyyy" />
                                    </div>
                                </div> */}                               
                                {/* <hr/> */}
                                
                                <div className="col-lg-3 mt-3" style={{"text-align":"right"}}>                                    
                                    <div  style={{display:'inline-block','vertical-align':"top"}}>
                                        <button type="submit" className="btn btn-primary mx-2" >Submit</button>
                                    </div>
                                    <div style={{display:'inline-block','vertical-align':"top"}}>
                                        <label> &nbsp; </label>
                                        <button type="button" className="btn btn-danger mx-2" id="cancelButton"  onClick={()=>{setRedeemDetail({});document.getElementById('redeemForm').reset()}}>Cancel</button>
                                    </div>
                                </div>
                            </form>
                            <div className="row mt-2">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">

                                        {/* <!-- end card header --> */}

                                        <div className="card-body">
                                            <table className="table table-striped table-hover table_client1" style={{"text-align":"left"}}>
                                                <thead>
                                                    <tr className="bg-primary" style={{ color: "white" }}>
                                                        <th scope="col">S.no.</th>
                                                        <th scope="col">Country</th>
                                                        <th scope="col">Currency</th>
                                                        <th scope="col">Symbol</th>
                                                        <th scope="col">Point Value</th>
                                                        <th scope="col">Status</th>
                                                        <th scope="col align-item-right">Action</th>
                                                    </tr>
                                                </thead>
                                                {(lists && lists.length > 0 )? (
                                                <tbody>
                                                    {lists?.map((list,index) => (
                                                        <tr key={list?.ID}>
                                                        <td>{(pageInfo.current_page-1)*pageInfo.perPage + ++index}</td>
                                                        <td>{list.countryName}</td>
                                                        <td>{list.currencyName} </td>
                                                        <td>{decodeHtml(list.currencySymbol)}</td>
                                                        <td>{list.currencyPoints}</td>
                                                        <td><div class="form-check form-switch">
                                                                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" defaultChecked={list.status==1?"checked":""} onClick={()=>updateRedeemStatus(list.ID,list.status)} />
                                                            </div></td>
                                                        <td className='align-item-right'>
                                                            {/* <button className="btn btn-sm btn-success" style={{width:"60px"}} onClick={()=>setRedeemFields(list)}><i className='mdi mdi-pencil'></i> Edit </button> */}
                                                                {/* <button className="btn btn-sm btn-danger" style={{width:"70px",'margin-left':"10px"}} onClick={()=>trashRedeem(list.ID)}><i className='mdi mdi-delete'></i> delete </button> */}
                                                                <div className="dropdown align-items-right">
                                                                    <div className="dropdown ms-sm-3 header-item topbar-user">
                                                                        <button type="button" className="btn btn-sm btn-success" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{'font-size':"14px"}}>
                                                                        More <i className="mdi mdi-dots-vertical-circle" ></i>
                                                                        </button>
                                                                        <div className="dropdown-menu dropdown-menu-end">
                                                                            <a className="dropdown-item" style={{cursor:"pointer"}} onClick={()=>setRedeemFields(list)} ><i className="mdi mdi-pencil"></i> Edit</a>
                                                                            <div className="dropdown-divider"></div>
                                                                            <a className="dropdown-item" style={{cursor:"pointer"}} onClick={()=>trashRedeem(list.ID)} ><i className="mdi mdi-delete"></i> Delete</a>                                                                            
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            
                                                        </td>
                                                    </tr>
                                                    ))}
                                                </tbody>
                                                ):(<>
                                                    <tr>
                                                        <td colSpan={9} id="dataMessage" style={{padding:"50px 0"}}>No data found</td>
                                                    </tr>
                                                </>)}
                                            </table>
                                            <Pagination pageInfo={pageInfo} changePage={changePage} />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* <!-- end row--> */}



                            {/* <!-- end row --> */}

                        </div>
                        {/* <!-- container-fluid --> */}
                    </div>
                    {/* <!-- End Page-content --> */}
                </div>
            </div>
            <Footer />

                       
        </div>

    )
}

export default Redeem;